
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[slug]",
      function () {
        return require("private-next-pages/courses/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[slug]"])
      });
    }
  